export const UserForgotPassword = {
	'Recover my password': 'Recover my password',
	'Enter document number or email':
		'Enter your document number or your email address',
	'11111111-1 or youremail@company.cl': '11111111-1 or youremail@company.com',
	'You will not be able to see this': 'You will not be able to see this',
	'Already registered? Sign in!': 'Already registered? Sign in!',
};
